import { components } from "components/meeting/modules";

export default {
  install: (app) => {
    components.forEach(({ name, component }) => {
      app.component(name, component);
    });
  },
};
